import DefaultBanner from './DefaultBanner';

export default DefaultBanner;
